import { proxy } from 'valtio'
import { DateTime } from 'luxon'
import {
    IDayHistoryResponse,
    InterpolatedPosition,
    PlaybackSpeed,
} from '../interfaces/dayHistory.ts'

const initialState = {
    active: false,
    pathData: null as IDayHistoryResponse | null,
    isPlaying: false,
    playbackSpeed: 360 as PlaybackSpeed,
    currentTime: 0,
    currentPosition: null as InterpolatedPosition | null,
    selectedDate: null as DateTime | null,
    loading: false,
    error: '',
}

export const dayHistoryState = proxy({ ...initialState })

export function resetDayHistory() {
    Object.assign(dayHistoryState, {
        active: false,
        pathData: null,
        isPlaying: false,
        playbackSpeed: 360 as PlaybackSpeed,
        currentTime: 0,
        currentPosition: null,
        selectedDate: null,
        loading: false,
        error: '',
    })
}

export default dayHistoryState
